const reduce = (acc, cur) => {
  if (!acc?.[cur?.code]) {
    return acc;
  }

  return { ...acc, [cur?.code]: { ...acc?.[cur?.code], [cur?.token]: cur?.value } };
};

export const mergeMessagesCallback =
  ({ setMessages, setIsCatchingMessages, localMessages }) =>
  entityMessages => {
    const mergedMessages = Object?.keys?.(localMessages)?.reduce?.(
      (acc, cur) => ({ ...acc, [cur]: { ...acc?.[cur], ...entityMessages?.[cur] } }),
      localMessages
    );

    setIsCatchingMessages?.(false);
    setMessages?.(mergedMessages);
  };

export const mergeMessages = ({ entityMessages: _entityMessages, localMessages }) => {
  if (!_entityMessages || !_entityMessages?.length) {
    return localMessages;
  }

  const accumulator = Object?.keys?.(localMessages)?.reduce?.((acc, locale) => ({ ...acc, [locale]: {} }), {}) ?? {};
  const entityMessages = _entityMessages?.reduce?.(reduce, accumulator) ?? accumulator;

  const mergedMessages = Object?.keys?.(localMessages)?.reduce?.(
    (acc, cur) => ({ ...acc, [cur]: { ...acc?.[cur], ...entityMessages?.[cur] } }),
    localMessages
  );

  return mergedMessages;
};
